/* eslint-disable react/jsx-curly-brace-presence */
import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { getSectionExtraField } from '~helpers/getters';
import DefaulTemplateOne from '~molecules/header/variants/default/template-one';
import Operator from '~molecules/header/variants/operator/template-one-two';
import ToplistHeader from '../../../../components/molecules/header/variants/toplist/template-one';
import ToplistHeaderTwo from '../../../../components/molecules/header/variants/toplist/template-two';
import ToplistHeaderThree from '../../../../components/molecules/header/variants/toplist/template-three';
import styles from './header.module.scss';

function Header({ section }) {
  const color = section.page?.extra_fields?.header_background_color || null;
  const ctaColor = section.page?.extra_fields?.cta_color;
  const colorCtaTxt = section.page?.extra_fields?.color_txt_cta;

  const operatorNameColor = section.page?.extra_fields?.bonus_operator_name_color;

  const relationContent = (pageSection) => {
    let ModuleComponent = null;

    switch (pageSection?.page?.template) {
      case 'operator_review': {
        const data = {
          page: pageSection?.page,
          author: pageSection?.page.author,
          type: pageSection?.page?.relation_type,
          template: pageSection?.page?.page_styles?.short_name,
          pageTemplate: pageSection?.page?.template,
          relation: pageSection?.page?.relation || {},
          name: pageSection?.page?.title || pageSection?.page?.relation?.name,
          ribbons: pageSection?.page?.relation?.ribbons || [],
          image: pageSection?.page?.relation?.logo,
          featureImg: pageSection?.page?.featured_image_object,
          extraFields: pageSection?.page?.extra_fields || {},
        };
        return <Operator {...data} />;
      }
      case 'toplist': {
        let props = {
          page: section.page,
          extraFields: section.page.extra_fields,
          imageObj: section.page.featured_image_object,
        };

        ModuleComponent = DefaulTemplateOne;
        props = {
          ...props,
          title: section?.page?.title,
          description:
            section?.page?.description ||
            getSectionExtraField(null, section?.page?.sections?.header, 'header_text'),
        };

        if (section?.page?.page_styles?.short_name === 'template_two') {
          return <ToplistHeaderTwo {...props} />;
        }
        if (section?.page?.page_styles?.short_name === 'template_three') {
          return <ToplistHeaderThree {...props} />;
        }
        return <ToplistHeader {...props} />;
      }
      default:
        return ModuleComponent;
    }
  };

  const getDefaultHeader = () => {
    const props = {
      title: section.page.title,
      description:
        section.page.description ||
        getSectionExtraField(null, section.page.sections?.header, 'header_text'),
    };
    return <DefaulTemplateOne {...props} />;
  };

  return (
    <header
      className={`${styles.header || ''}   ${
        styles[section.page.template] ? styles[section.page.template] || '' : ''
      }     ${styles[section.page.relation_type] ? styles[section.page.relation_type] || '' : ''}`}
      style={{
        background: color || ``,
        '--primary-button-color': ctaColor || ``,
        '--header-bonus-name-color': operatorNameColor || ``,
        '--primary-button-color-text': colorCtaTxt || ``,
      }}
    >
      {section?.page?.template === 'default' ? (
        getDefaultHeader()
      ) : (
        <Suspense fallback={<div className={`${styles.test}`} />}>
          {relationContent(section)}
        </Suspense>
      )}
    </header>
  );
}

Header.propTypes = {
  section: PropTypes.shape({
    allMarkets: PropTypes.shape([PropTypes.shape({})]),
    page: PropTypes.shape({
      page_styles: PropTypes.shape({
        short_name: PropTypes.string,
      }),
      extra_fields: PropTypes.shape({
        header_background_color: PropTypes.string,
        cta_color: PropTypes.string,
        color_txt_cta: PropTypes.string,
        bonus_operator_name_color: PropTypes.string,
      }),
      description: PropTypes.string,
      template: PropTypes.string,
      relation_type: PropTypes.string,
      type: PropTypes.string,
      path: PropTypes.string,
      updated_at: PropTypes.string,
      created_at: PropTypes.string,
      reading_time: PropTypes.number,
      reviewer: PropTypes.string,
      reviewer_id: PropTypes.number,
      featured_image_object: PropTypes.shape({}),
      author: PropTypes.shape({
        name: PropTypes.string,
        profile_page_path: PropTypes.string,
        image: PropTypes.string,
      }),
      relation: PropTypes.shape({
        url: PropTypes.string,
        email: PropTypes.string,
      }),
      authors: PropTypes.shape([PropTypes.shape({})]),
      sections: PropTypes.shape({
        header: PropTypes.shape({
          extra_fields: PropTypes.shape({
            header_background_image: PropTypes.oneOfType([
              PropTypes.string,
              PropTypes.shape({
                value: PropTypes.string,
                type: PropTypes.string,
              }),
            ]),
            header_text: PropTypes.oneOfType([
              PropTypes.string,
              PropTypes.shape({
                value: PropTypes.string,
                type: PropTypes.string,
              }),
            ]),
          }),

          modules: PropTypes.shape({
            forEach: PropTypes.shape({}),
          }),
        }),
      }),
      title: PropTypes.string,
    }),
  }).isRequired,
  showHeaderBg: PropTypes.bool,
  moreImages: PropTypes.shape({
    fileImage: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  bonusIcon: PropTypes.shape({
    fileImage: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  buttonIcon: PropTypes.shape({}),
};

export default Header;
